import React from "react";

import styles from "./Graph.module.scss";

export default function AttractionRemote2 () {
    const svg = `
<svg width="602px" height="432px" viewBox="0 0 602 432" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g>
            <text font-family="OpenSans-Semibold, Open Sans" font-size="15" font-weight="500" fill="#000000">
                <tspan x="271.714111" y="22">Londres</tspan>
            </text>
            <text font-family="OpenSans-Semibold, Open Sans" font-size="15" font-weight="500" fill="#000000">
                <tspan x="254.106689" y="62">Île-de-France</tspan>
            </text>
            <text font-family="OpenSans-Semibold, Open Sans" font-size="15" font-weight="500" fill="#000000">
                <tspan x="275.057617" y="102">Madrid</tspan>
            </text>
            <text font-family="OpenSans-Semibold, Open Sans" font-size="15" font-weight="500" fill="#000000">
                <tspan x="264.675537" y="142">Barcelone</tspan>
            </text>
            <text font-family="OpenSans-Semibold, Open Sans" font-size="15" font-weight="500" fill="#000000">
                <tspan x="279.551025" y="182">Berlin</tspan>
            </text>
            <text font-family="OpenSans-Semibold, Open Sans" font-size="15" font-weight="500" fill="#000000">
                <tspan x="262.427002" y="222">Hambourg</tspan>
            </text>
            <text font-family="OpenSans-Semibold, Open Sans" font-size="15" font-weight="500" fill="#000000">
                <tspan x="279.422852" y="262">Hesse</tspan>
            </text>
            <text font-family="OpenSans-Semibold, Open Sans" font-size="15" font-weight="500" fill="#000000">
                <tspan x="236.528564" y="302">Rhénanie N.-West</tspan>
            </text>
            <text font-family="OpenSans-Semibold, Open Sans" font-size="15" font-weight="500" fill="#000000">
                <tspan x="255.897461" y="342">Baden Wurt.</tspan>
            </text>
            <text font-family="OpenSans-Semibold, Open Sans" font-size="15" font-weight="500" fill="#000000">
                <tspan x="261.841064" y="382">Lombardie</tspan>
            </text>
            <text font-family="OpenSans-Semibold, Open Sans" font-size="15" font-weight="500" fill="#000000">
                <tspan x="275.614258" y="422">Latium</tspan>
            </text>
            <g>
                <rect fill="#8593C7" x="0" y="0" width="220" height="32"></rect>
                <rect fill="#586EBD" x="39" y="0" width="181" height="32"></rect>
                <rect fill="#4A54A4" x="72" y="0" width="148" height="32"></rect>
                <rect fill="#2E377F" x="113" y="0" width="107" height="32"></rect>
                <text font-family="OpenSans-Bold, Open Sans" font-size="16" font-weight="bold" fill="#FFFFFF">
                    <tspan x="12.3671875" y="22">18</tspan>
                </text>
                <text font-family="OpenSans-Bold, Open Sans" font-size="16" font-weight="bold" fill="#FFFFFF">
                    <tspan x="46.3671875" y="22">15</tspan>
                </text>
                <text font-family="OpenSans-Bold, Open Sans" font-size="16" font-weight="bold" fill="#FFFFFF">
                    <tspan x="82.3671875" y="22">18</tspan>
                </text>
                <text font-family="OpenSans-Bold, Open Sans" font-size="16" font-weight="bold" fill="#FFFFFF">
                    <tspan x="156.367188" y="22">49</tspan>
                </text>
            </g>
            <g transform="translate(0.000000, 40.000000)">
                <rect fill="#8593C7" x="0" y="0" width="220" height="32"></rect>
                <rect fill="#586EBD" x="80" y="0" width="140" height="32"></rect>
                <rect fill="#4A54A4" x="132" y="0" width="88" height="32"></rect>
                <rect fill="#2E377F" x="167" y="0" width="53" height="32"></rect>
            </g>
            <g transform="translate(0.000000, 80.000000)">
                <rect fill="#8593C7" x="0" y="0" width="220" height="32"></rect>
                <rect fill="#586EBD" x="51" y="0" width="169" height="32"></rect>
                <rect fill="#4A54A4" x="104" y="0" width="116" height="32"></rect>
                <rect fill="#2E377F" x="147" y="0" width="73" height="32"></rect>
            </g>
            <g transform="translate(0.000000, 120.000000)">
                <rect fill="#8593C7" x="0" y="0" width="220" height="32"></rect>
                <rect fill="#586EBD" x="82" y="0" width="138" height="32"></rect>
                <rect fill="#4A54A4" x="137" y="0" width="83" height="32"></rect>
                <rect fill="#2E377F" x="178" y="0" width="42" height="32"></rect>
            </g>
            <g transform="translate(0.000000, 160.000000)">
                <rect fill="#8593C7" x="0" y="0" width="220" height="32"></rect>
                <rect fill="#586EBD" x="103" y="0" width="117" height="32"></rect>
                <rect fill="#4A54A4" x="156" y="0" width="64" height="32"></rect>
                <rect fill="#2E377F" x="178" y="0" width="42" height="32"></rect>
            </g>
            <g transform="translate(0.000000, 200.000000)">
                <rect fill="#8593C7" x="0" y="0" width="220" height="32"></rect>
                <rect fill="#586EBD" x="116" y="0" width="104" height="32"></rect>
                <rect fill="#4A54A4" x="151" y="0" width="69" height="32"></rect>
                <rect fill="#2E377F" x="173" y="0" width="47" height="32"></rect>
            </g>
            <g transform="translate(0.000000, 240.000000)">
                <rect fill="#8593C7" x="0" y="0" width="220" height="32"></rect>
                <rect fill="#586EBD" x="91" y="0" width="129" height="32"></rect>
                <rect fill="#4A54A4" x="127" y="0" width="93" height="32"></rect>
                <rect fill="#2E377F" x="164" y="0" width="56" height="32"></rect>
            </g>
            <g transform="translate(0.000000, 280.000000)">
                <rect fill="#8593C7" x="0" y="0" width="220" height="32"></rect>
                <rect fill="#586EBD" x="105" y="0" width="115" height="32"></rect>
                <rect fill="#4A54A4" x="147" y="0" width="73" height="32"></rect>
                <rect fill="#2E377F" x="179" y="0" width="41" height="32"></rect>
            </g>
            <g transform="translate(0.000000, 320.000000)">
                <rect fill="#8593C7" x="0" y="0" width="220" height="32"></rect>
                <rect fill="#586EBD" x="118" y="0" width="102" height="32"></rect>
                <rect fill="#4A54A4" x="151" y="0" width="69" height="32"></rect>
                <rect fill="#2E377F" x="177" y="0" width="43" height="32"></rect>
            </g>
            <g transform="translate(0.000000, 360.000000)">
                <rect fill="#8593C7" x="0" y="0" width="220" height="32"></rect>
                <rect fill="#586EBD" x="62" y="0" width="158" height="32"></rect>
                <rect fill="#4A54A4" x="131" y="0" width="89" height="32"></rect>
                <rect fill="#2E377F" x="177" y="0" width="43" height="32"></rect>
            </g>
            <g transform="translate(0.000000, 400.000000)">
                <rect fill="#8593C7" x="0" y="0" width="220" height="32"></rect>
                <rect fill="#586EBD" x="71" y="0" width="149" height="32"></rect>
                <rect fill="#4A54A4" x="115" y="0" width="105" height="32"></rect>
                <rect fill="#2E377F" x="154" y="0" width="66" height="32"></rect>
            </g>
            <g transform="translate(382.000000, 0.000000)">
                <rect fill="#2E377F" x="0" y="0" width="220" height="32"></rect>
                <rect fill="#8593C7" x="152" y="0" width="68" height="32"></rect>
                <rect fill="#586EBD" x="190" y="0" width="30" height="32"></rect>
                <text font-family="OpenSans-Bold, Open Sans" font-size="16" font-weight="bold" fill="#FFFFFF">
                    <tspan x="68.3671875" y="22">70</tspan>
                </text>
                <text font-family="OpenSans-Bold, Open Sans" font-size="16" font-weight="bold" fill="#FFFFFF">
                    <tspan x="161.367188" y="22">17</tspan>
                </text>
                <text font-family="OpenSans-Bold, Open Sans" font-size="16" font-weight="bold" fill="#FFFFFF">
                    <tspan x="195.367188" y="22">13</tspan>
                </text>
            </g>
            <g transform="translate(382.000000, 40.000000)">
                <rect fill="#2E377F" x="0" y="0" width="220" height="32"></rect>
                <rect fill="#8593C7" x="166" y="0" width="54" height="32"></rect>
                <rect fill="#586EBD" x="204" y="0" width="16" height="32"></rect>
            </g>
            <g transform="translate(382.000000, 80.000000)">
                <rect fill="#2E377F" x="0" y="0" width="220" height="32"></rect>
                <rect fill="#8593C7" x="168" y="0" width="52" height="32"></rect>
                <rect fill="#586EBD" x="198" y="0" width="22" height="32"></rect>
            </g>
            <g transform="translate(382.000000, 120.000000)">
                <rect fill="#2E377F" x="0" y="0" width="220" height="32"></rect>
                <rect fill="#8593C7" x="140" y="0" width="80" height="32"></rect>
                <rect fill="#586EBD" x="164" y="0" width="56" height="32"></rect>
            </g>
            <g transform="translate(382.000000, 160.000000)">
                <rect fill="#2E377F" x="0" y="0" width="220" height="32"></rect>
                <rect fill="#8593C7" x="151" y="0" width="69" height="32"></rect>
                <rect fill="#586EBD" x="188" y="0" width="32" height="32"></rect>
            </g>
            <g transform="translate(382.000000, 200.000000)">
                <rect fill="#2E377F" x="0" y="0" width="220" height="32"></rect>
                <rect fill="#8593C7" x="120" y="0" width="100" height="32"></rect>
                <rect fill="#586EBD" x="210" y="0" width="10" height="32"></rect>
            </g>
            <g transform="translate(382.000000, 240.000000)">
                <rect fill="#2E377F" x="0" y="0" width="220" height="32"></rect>
                <rect fill="#8593C7" x="153" y="0" width="67" height="32"></rect>
                <rect fill="#586EBD" x="197" y="0" width="23" height="32"></rect>
            </g>
            <g transform="translate(382.000000, 280.000000)">
                <rect fill="#2E377F" x="0" y="0" width="220" height="32"></rect>
                <rect fill="#8593C7" x="155" y="0" width="65" height="32"></rect>
                <rect fill="#586EBD" x="192" y="0" width="28" height="32"></rect>
            </g>
            <g transform="translate(382.000000, 320.000000)">
                <rect fill="#2E377F" x="0" y="0" width="220" height="32"></rect>
                <rect fill="#8593C7" x="160" y="0" width="60" height="32"></rect>
                <rect fill="#586EBD" x="190" y="0" width="30" height="32"></rect>
            </g>
            <g transform="translate(382.000000, 360.000000)">
                <rect fill="#2E377F" x="0" y="0" width="220" height="32"></rect>
                <rect fill="#8593C7" x="173" y="0" width="47" height="32"></rect>
                <rect fill="#586EBD" x="208" y="0" width="12" height="32"></rect>
            </g>
            <g transform="translate(382.000000, 400.000000)">
                <rect fill="#2E377F" x="0" y="0" width="220" height="32"></rect>
                <rect fill="#8593C7" x="152" y="0" width="68" height="32"></rect>
                <rect fill="#586EBD" x="188" y="0" width="32" height="32"></rect>
            </g>
        </g>
    </g>
</svg>`;

    const legend = `
<svg width="590px" height="97px" viewBox="0 0 590 97" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g transform="translate(0.000000, -4.000000)">
            <g>
                <rect fill="#8593C7" x="0" y="55" width="16" height="16"></rect>
                <text font-family="OpenSans-Regular, Open Sans" font-size="16" font-weight="normal" fill="#000000">
                    <tspan x="24" y="67">0 jours</tspan>
                </text>
                <rect fill="#2E377F" x="0" y="85" width="16" height="16"></rect>
                <text font-family="OpenSans-Regular, Open Sans" font-size="16" font-weight="normal" fill="#000000">
                    <tspan x="24" y="97">5 et plus</tspan>
                </text>
                <rect fill="#586EBD" x="95" y="55" width="16" height="16"></rect>
                <text font-family="OpenSans-Regular, Open Sans" font-size="16" font-weight="normal" fill="#000000">
                    <tspan x="119" y="67">1-2</tspan>
                </text>
                <rect fill="#4A54A4" x="163" y="55" width="16" height="16"></rect>
                <text font-family="OpenSans-Regular, Open Sans" font-size="16" font-weight="normal" fill="#000000">
                    <tspan x="187" y="67">3-4</tspan>
                </text>
                <text font-family="OpenSans-Semibold, Open Sans" font-size="15" font-weight="500" line-spacing="20" fill="#000000">
                    <tspan x="0" y="16">Pourcentage actuel de jours de </tspan>
                    <tspan x="0" y="36">télétravail depuis la maison</tspan>
                </text>
            </g>
            <g transform="translate(350.000000, 0.000000)">
                <rect fill="#2E377F" x="0" y="77" width="16" height="16"></rect>
                <text font-family="OpenSans-Regular, Open Sans" font-size="16" font-weight="normal" fill="#000000">
                    <tspan x="24" y="89">Oui</tspan>
                </text>
                <rect fill="#8593C7" x="71" y="77" width="16" height="16"></rect>
                <text font-family="OpenSans-Regular, Open Sans" font-size="16" font-weight="normal" fill="#000000">
                    <tspan x="95" y="89">Non</tspan>
                </text>
                <rect fill="#586EBD" x="147" y="77" width="16" height="16"></rect>
                <text font-family="OpenSans-Regular, Open Sans" font-size="16" font-weight="normal" fill="#000000">
                    <tspan x="171" y="89">Peut-être</tspan>
                </text>
                <text font-family="OpenSans-Semibold, Open Sans" font-size="15" font-weight="500" line-spacing="20" fill="#000000">
                    <tspan x="0" y="16">Pourcentage ayant travaillé de la </tspan>
                    <tspan x="0" y="36">maison lors du Covid-19 voulant </tspan>
                    <tspan x="0" y="56">télétravailler à l’avenir</tspan>
                </text>
            </g>
        </g>
    </g>
</svg>`;
    return (
        <div className={styles.Column}>
            <div dangerouslySetInnerHTML={{__html: legend}} className={styles.Legend}/>
            <div dangerouslySetInnerHTML={{__html: svg}} className={[styles.Graph, styles.Full].join(' ')}/>
        </div>
    )
}
